
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { CountryInfo, VInput, VSelect } from '@/features/common/types';

@Component
export default class CountrySelect extends Vue {
  @Prop({ required: true }) value!: string;

  @Prop({ default: '' }) label!: string;

  @Prop({ required: false, default: false }) onlyCanada!: boolean;

  @Prop({ required: false, default: false }) onlyCanadaAndUs!: boolean;

  @Prop({ required: false, default: null }) allowedCountryCodes!: string[] | null;

  @Prop({ default: true }) showLabel!: boolean;

  get countries(): Array<CountryInfo> {
    const { countries } = this.$store.state;

    if (!countries || !countries.length) return [];

    if (this.allowedCountryCodes && this.allowedCountryCodes.length > 0) {
      return countries.filter((c) => this.allowedCountryCodes?.includes(c.code));
    }

    if (this.onlyCanadaAndUs) {
      return countries.filter((c) => c.code === 'CA' || c.code === 'US');
    }

    if (this.onlyCanada) {
      return [
        countries.find((c) => c.code === 'CA'),
      ];
    }

    return countries;
  }

  get countryValue(): string {
    if (!this.value) return '';

    const country = this.countries.find(
      (c) => c.code.toLowerCase() === this.value.toLowerCase(),
    );
    if (!country) return '';

    return country.code;
  }

  mounted(): void {
    const { input } = this.$refs;
    if (!input) return;

    const { input: autocompleteInput } = (input as VInput).$refs;
    if (!autocompleteInput) return;

    (autocompleteInput as HTMLInputElement).addEventListener('focus', this.onFocus, true);
  }

  private async onFocus() {
    const { input } = this.$refs;
    if (!input) return;

    await this.$nextTick();
    (input as VSelect).isMenuActive = true;
  }
}
